(function() {
	'use strict';

	angular.module('nasracApp').config(
			[ '$compileProvider', function($compileProvider) {
				$compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
			} ]).controller('RevenueController', RevenueController);

	RevenueController.$inject = [ '$scope', 'Revenue', 'AuthServerProvider',
			'DTOptionsBuilder' ];

	function RevenueController($scope, Revenue, AuthServerProvider,
			DTOptionsBuilder) {
		//var vm = this;
        $scope.selectedMonth;

        $scope.loadData = function() {

			Revenue.query({
				date : $scope.selectedMonth.reportDate.substring(0, 10)
			}, function(result) {
                $scope.date = $scope.selectedMonth;
                $scope.revenueList = result;
				$scope.currentTime = new Date(new Date().getTime()).toLocaleTimeString() + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();
				$scope.getTotal(result);
			});
		};
		$scope.getTotal = function (result){
			$scope.total = {};
			$scope.total.digitalMot = 0;
			$scope.total.digitalNonMot = 0 ;
			$scope.total.dta = 0;
			$scope.total.totalactiveUnits = 0;
			$scope.total.serviceCharge = 0;
				angular.forEach(result,function(revenue,index){
					$scope.total.digitalMot = $scope.total.digitalMot + revenue.digitalMot;
					$scope.total.digitalNonMot = $scope.total.digitalNonMot + revenue.digitalNonMot;
					$scope.total.dta = $scope.total.dta + revenue.dta;
					$scope.total.totalactiveUnits = $scope.total.totalactiveUnits + revenue.totalactiveUnits;
					$scope.total.serviceCharge = $scope.total.serviceCharge + revenue.serviceCharge;
				});
		};

		Revenue.getReportDates(function(result) {
			$scope.reportDate = result;
            $scope.selectedMonth = result[0];

		});

		$scope.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
			.withDisplayLength(25)
			.withButtons([ {
			//extend: 'csvHtml5', // removing action column
			text : 'Export',
			key : '1',
			action : function(e, dt, node, config) {

				Revenue.download({

					date : $scope.selectedMonth.reportDate.substring(0, 10)
				}).$promise.then(function(data) {
					var url = URL.createObjectURL(data.response);
					var link = document.createElement("a");
					link.href = url;

					//set the visibility hidden so it will not effect on your web-layout
					link.style = "visibility:hidden";
					link.download = "Revenue_summary_For_"+$scope.selectedMonth.reportDateLabel+".xlsx"; //this is an example file to download, use yours

					//this part will append the anchor tag and remove it after automatic click
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			}
		} ]).withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")


	}
})();
